import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { Row } from "@xo-union/tk-component-grid";
import { compose } from "@xo-union/react-css-modules";
import styles from "../../css/styles.css";
var FormRow = function FormRow(props) {
  return /*#__PURE__*/React.createElement(Row, _extends({
    classes: compose({
      row: styles.row
    })
  }, props));
};
export default FormRow;